import React from 'react';
import { Modal, Select, InputNumber, Form, Popover, Button } from 'antd';
import PropTypes from 'prop-types';
import PlugwrapThickness from '../../components/PlugwrapThickness';
import './tipVent.css';
import Translation from '../../Translation';
import { utils } from '../../config';

const Option = Select.Option;
const FormItem = Form.Item;

/**
 * Class for tip vent.
 *
 * @class TipVent
 * @extends {React.Component}
 */
class TipVent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            perforation: '',
            permeability: 0,
            porosity: 0,
            tipvent: 0,
            selectButtonDisplay: 'displayInlineBlock',
            visibleplugwrap: false,
            isPlugwrapVisible: false,
            errTextCalculate: '',
            visible: false,
            canSelect: false,
            errTextSelect: '',
            visibleSelect: false
        };

        this.handleCalculate = this.handleCalculate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updatePorosityValue = this.updatePorosityValue.bind(this);
        this.checkIfValuesAreInRange = this.checkIfValuesAreInRange.bind(this);
        this.checkIfTwoValuesNull = this.checkIfTwoValuesNull.bind(this);
        this.checkIfAllFilled = this.checkIfAllFilled.bind(this);
        this.updateTipVentValue = this.updateTipVentValue.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.enter, false);
        if (this.props.openingTipVentFromHeader) {
            this.setState({
                selectButtonDisplay: 'displayNone',
            });
        }
    }

    /**
     * enter function calls the calculation function when the enter key is pressed
     * @param {*} event here event is an event passed
     * @memberof TipVent
     */
    enter = (event)=>{
        if(event.keyCode === 13) {
          this.handleCalculate();
          this.setState({
              visible: true
          });
        }
      }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.enter, false);
      }

    /**
     * hide function is used to close the popover over calculate button
     * 
     * @memberof TipVent
     */
    hide = () => {
        this.setState({
            visible: false,
        });
    }

    /**
     * hideSelect function is used to close the popover over select button
     * 
     * @memberof TipVent
     */
    hideSelect = () => {
        this.setState({
            visibleSelect: false,
        });
    }

    /**
     * handleVisibleChange function sets the visibility of the popover over calculate button
     * 
     * @memberof TipVent
     */
    handleVisibleChange = (visible) => {
        this.setState({ visible });
    }

    /**
     * handleVisibleChangeSelect function sets the visibility of the popover over select button
     * 
     * @memberof TipVent
     */
    handleVisibleChangeSelect = (visibleSelect) => {
        this.setState({ visibleSelect });
    }

    /**
     * handleClear function is for clearing the fields on the form
     * 
     * @memberof TipVent
     */
    handleClear() {
        this.props.form.resetFields();
        this.setState({
            perforation: ''
        });
    }

    /**
     * handlePlugwrapCancel function closes the plugwrap window
     * 
     * @memberof TipVent
     */
    handlePlugwrapCancel = () => {
        this.setState({
            isPlugwrapVisible: false
        });
    }

    /**
     * showPlugwrapModal function opens the plugwrap window
     * 
     * @memberof TipVent
     */
    showPlugwrapModal = () => {
        this.setState({
            isPlugwrapVisible: true
        });
    }

    /**
     * updatePorosityValue function sets the value of the porosity field
     * @param {} data is the porosity value
     * @memberof TipVent
     */
    updatePorosityValue(data) {
        this.props.form.setFieldsValue({
            porosity: data,
        });
    }

    /**
     * handleChange function takes the perforation value selected from the dropdown
     * @param {} value is the perforation value
     * @memberof TipVent
     */
    handleChange(value) {
        this.setState({
            perforation: value
        });
    }

    /**
     * validateNumberInputFields validates the value so that it contains only numbers and alphabets.
     * @param {} rule
     * @param {String} value it is the value user types in the field
     * @param {} callback
     * @memberof CreatePlugwrap
     */
    validateNumberInputFields = (rule, value, callback) => {
        var numbers= /^[0-9]\d*(\.\d+)?$/;
        
        if(value && value.length && !value.match(numbers)) {
            callback(utils.getTranslationText('msg_plz_enter_number', 'Please enter a number'));
        }
        else {
            callback();
        }
    }

    /**
     * handleCalculate function calculates the value of tipping paper permeability, plugwrap porosity or tip ventilation
     * 
     * @memberof CreatePlugwrap
     */
    handleCalculate() {
        this.setState({
            errTextCalculate: ''
        })
        let tipObj;

        this.props.form.validateFields((err, values) => {
            if (!err) {
                let obj = {
                    'perforation': this.state.perforation,
                };

                tipObj = Object.assign(obj, values);
            }
        });

        if (this.checkIfTwoValuesNull(tipObj)) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_two_out_three_values_filled', 'Two out of three values must be filled')
            });
        }
        else {
            if (this.checkIfAllFilled(tipObj)) {
                this.setState({
                    errTextCalculate: utils.getTranslationText('msg_one_must_left_blank_order_calculate', 'One value must be left blank in order to calculate')
                });
            }
            else {
                this.checkIfValuesAreInRange(tipObj);
            }
        }
    }

    /**
     * checkIfTwoValuesNull function keeps a check that at all times one field should be left empty for the calculation to take place.
     * 
     * @param {object} tipObj 
     * @memberof CreatePlugwrap
     */
    checkIfTwoValuesNull(tipObj) {
        if (((tipObj.permeability == null) && (tipObj.porosity == null)) ||
            ((tipObj.porosity == null) && (tipObj.tipvent == null)) ||
            ((tipObj.permeability == null) && (tipObj.tipvent == null))) {
            return true;
        }
        return false;
    }

    /**
     * checkIfAllFilled function keeps a check if all fields are filled.
     * 
     * @param {object} tipObj 
     * @memberof CreatePlugwrap
     */
    checkIfAllFilled(tipObj) {
        if ((tipObj.permeability != null) &&
            (tipObj.porosity != null) &&
            (tipObj.tipvent != null)) {
            return true;
        }
        return false;
    }

    /**
     * checkIfValuesAreInRange function checks if the fields are in range.
     * 
     * @param {object} tipObj 
     * @memberof CreatePlugwrap
     */
    checkIfValuesAreInRange(tipObj) {
        let flag= true;
        if ((tipObj.tipvent < 20) || (tipObj.tipvent > 78)) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_ventilation_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. % Ventilation Range: 20 - 78%')
            });
        }
        if ((tipObj.porosity < 1700) || (tipObj.porosity > 26000)) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_plugwrap_porosity_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. Plugwrap Porosity Range: 1700 - 26000 Coresta')
            });
        }
        if (tipObj.perforation === '') {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_perforation_method', 'Please select a Perforation method.')
            });
            flag=false;
        }
        if ((tipObj.perforation === 'Microlaser') &&
            ((tipObj.permeability < 550) || (tipObj.permeability > 2400))) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_micro_tipping_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. Microlaser Tipping Range: 550 - 2400 Coresta')
            });
        }
        else if ((tipObj.perforation === 'Macrolaser') &&
            ((tipObj.permeability < 1600) || (tipObj.permeability > 3500))) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_macro_tipping_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. Macrolaser Tipping Range: 1600 - 3500 Coresta')
            });
        }
        else if ((tipObj.perforation === 'Electrostatic') &&
            ((tipObj.permeability < 600) || (tipObj.permeability > 2400))) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_electrostatic_tipping_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. Electrostatic Tipping Range: 600 - 2400 Coresta')
            });
        }
        else if ((tipObj.perforation === 'Mechanical') &&
            ((tipObj.permeability < 1800) || (tipObj.permeability > 3200))) {
            this.setState({
                errTextCalculate: utils.getTranslationText('msg_error_mechanical_tipping_range', 'This value falls outside the ventilation study range and may lead to inaccurate predictions. Mechanical Tipping Range: 1800 - 3200 Coresta')
            });
        }

        if(flag) {
            this.calculate(tipObj);
        }
    }

    /**
     * calculate function performs the calculation based on the perforation method selected.
     * 
     * @param {object} tipObj 
     * @memberof CreatePlugwrap
     */
    calculate(tipObj) {
        let a, b, c;
        let tipvent = parseFloat(tipObj.tipvent);
        let porosity = parseFloat(tipObj.porosity);
        let permeability = parseFloat(tipObj.permeability);

        if (tipObj.perforation === 'Microlaser') {
            a = 0.1272; b = 0.2032; c = 0.5652;
        }
        else if (tipObj.perforation === 'Macrolaser') {
            a = 0.0835; b = 0.2442; c = 0.5237;
        }
        else if (tipObj.perforation === 'Electrostatic') {
            a = 0.4305; b = 0.1257; c = 0.5033;
        }
        else if (tipObj.perforation === 'Mechanical') {
            a = 0.1186; b = 0.2752; c = 0.4237;
        }


        if (tipObj.permeability == null) {
            permeability = (tipvent / (a * porosity ** b)) ** (1 / c);
            permeability = permeability.toFixed(1);
            this.props.form.setFieldsValue({
                permeability: permeability,
            });
        }
        else if (tipObj.porosity == null) {
            porosity = (tipvent / (a * permeability ** c)) ** (1 / b);
            porosity = porosity.toFixed(1);
            this.props.form.setFieldsValue({
                porosity: porosity,
            });
        }
        else if (tipObj.tipvent == null) {
            tipvent = permeability ** c * a * porosity ** b;
            tipvent = tipvent.toFixed(1);
            this.props.form.setFieldsValue({
                tipvent: tipvent,
            });
        }

        this.setState({
            canSelect: true,
            errTextSelect: '',
            tipvent: tipvent
        });
    }

    /**
     * handleCancel function closes the tipvent window.
     *  
     * @memberof CreatePlugwrap
     */
    handleCancel() {
        this.handleClear();
        if (this.props.openingTipVentFromHeader) {
            this.props.showTipVentScreen(false);
        }
        else {
            this.props.showTipForForm(false);
        }
    }

    /**
     * updateTipVentValue function return the tipvent field value.
     *  
     * @memberof CreatePlugwrap
     */
    updateTipVentValue() {
        if (this.state.canSelect) {
            this.props.updateTipValue(this.state.tipvent);
            if (this.props.openingTipVentFromHeader) {
                this.props.showTipVentScreen(false);
            }
            else {
                this.props.showTipForForm(false);
            }
        }
        else {
            this.setState({
                errTextSelect: utils.getTranslationText('msg_calculate_first', 'You need to calculate first')
            });
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const content = (
            <div>
                <p>{this.state.errTextCalculate || ""}</p>
                <a className="close-popover" onClick={this.hide}><Translation labelName="btn_close" defaultText="Close"/></a>
            </div>
        );
        const errLength = this.state.errTextCalculate.length ? true : false;
        const contentSelect = (
            <div>
                <p>{this.state.errTextSelect || ""}</p>
                <a className="close-popover" onClick={this.hideSelect}><Translation labelName="btn_close" defaultText="Close"/></a>
            </div>
        );
        const errSelectLength = this.state.errTextSelect.length ? true : false;
        return (
            <div>
                <Modal
                    title={<Translation labelName="title_tip_ventilation_calculation" defaultText="Tip Ventilation Calculation"/>}
                    visible={this.props.isTipVisible}
                    footer={null}
                    width="40%"
                    centered
                    style={{ top: 20 }}
                    onCancel={() => this.handleCancel()}>
                    <div className="plugwrap-container">
                        <div className="tipvent-container">
                            {/* <a href='/help/html/Calculate_Ventilation_Level.htm' target="_blank" className="help-section">
                                <img
                                    src="./images/help-inverse-black.svg"
                                    alt="help"
                                    className="help-icon" />
                            </a> */}
                            <Form id="test">
                                <label><Translation labelName="lbl_perforation_method" defaultText="Perforation Method"/></label>
                                <Select
                                    onChange={this.handleChange}
                                    placeholder='Select a method'
                                    value={this.state.perforation}
                                    className="tipvent-container__select">

                                    <Option value="Microlaser"><Translation labelName="txt_microlaser" defaultText="Microlaser"/></Option>
                                    <Option value="Macrolaser"><Translation labelName="txt_macrolaser" defaultText="Macrolaser"/></Option>
                                    <Option value="Electrostatic"><Translation labelName="txt_electrostatic" defaultText="Electrostatic"/></Option>
                                    <Option value="Mechanical"><Translation labelName="txt_mechanical" defaultText="Mechanical"/></Option>
                                </Select>
                                <FormItem label={<Translation labelName="lbl_tipping_papar" defaultText="Tipping Paper Permeability"/>}>
                                    {getFieldDecorator('permeability', {
                                rules: [{ validator: this.validateNumberInputFields}],
                            })(
                                <InputNumber />
                            )}

                                </FormItem>
                                <div className="tip-vent">
                                    <FormItem label={<Translation labelName="lbl_plugwrap_porosity" defaultText="Plugwrap Porosity"/>} className="tip-vent__porosity">
                                        {getFieldDecorator('porosity', {
                                rules: [{ validator: this.validateNumberInputFields}],
                            })(
                                <InputNumber />
                            )}
                                    </FormItem>
                                    <Button
                                        type="Primary"
                                        icon="setting"
                                        className="btn-custom plugwrap"
                                        onClick={this.showPlugwrapModal} />

                                </div>
                                <FormItem label={<Translation labelName="lbl_Tip_ventilation" defaultText="% Tip Ventilation"/>}>
                                    {getFieldDecorator('tipvent', {
                                rules: [{ validator: this.validateNumberInputFields}],
                            })(
                                <InputNumber />
                            )}
                                </FormItem>
                                <div className="btn-group">
                                    <Popover
                                        content={content}
                                        trigger="click"
                                        placement="topLeft"
                                        visible={errLength && this.state.visible}
                                        onVisibleChange={this.handleVisibleChange}>
                                        <button
                                            type="button"
                                            className="btn btn-default btn-calculate"
                                            onClick={() => this.handleCalculate()}
                                        ><Translation labelName="btn_calculate" defaultText="CALCULATE"/></button>
                                    </Popover>
                                    <span className={this.state.selectButtonDisplay}>
                                        <Popover
                                            placement="topLeft"
                                            content={contentSelect}
                                            trigger="click"
                                            visible={errSelectLength && this.state.visibleSelect}
                                            onVisibleChange={this.handleVisibleChangeSelect}>
                                            <button
                                                value="select"
                                                type="button"
                                                className="btn btn-default"
                                                onClick={this.updateTipVentValue}><Translation labelName="btn_select" defaultText="SELECT"/></button>
                                        </Popover>
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={this.handleClear}><Translation labelName="btn_clear" defaultText="CLEAR"/></button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal>
                {this.state.isPlugwrapVisible && <Modal
                    visible={this.state.isPlugwrapVisible}
                    footer={null}
                    width='80%'
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        updatePorosityValue={this.updatePorosityValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}
                        rowSelectionDisable={true}
                        openingFromTipVent={true}>
                    </PlugwrapThickness>
                </Modal>}
            </div>
        );
    }
}

const DefaultTipVent = Form.create()(TipVent);

export default DefaultTipVent;

TipVent.propTypes = {
    form: PropTypes.object,
    isTipVisible: PropTypes.bool,
    showTipForForm: PropTypes.func,
    openingTipVentFromHeader: PropTypes.bool,
    showTipVentScreen: PropTypes.func,
    updateTipValue: PropTypes.func,
}


// WEBPACK FOOTER //
// ./src/components/TipVent/index.js